import { render, staticRenderFns } from "./Paros.vue?vue&type=template&id=5749cd6a&"
import script from "./Paros.vue?vue&type=script&lang=js&"
export * from "./Paros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports